import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import network from 'network/network'

const initialState = {
    data: {},
    loading: false,
    error: null
}

export const getDailyUsage = createAsyncThunk('dailyUsage/getDailyUsage', async () => {
    const response = await network.get("/admin/Campaign/get-daily");
    return response.data;
})

export const dailyUsageSlice = createSlice({
    name: 'dailyUsage',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDailyUsage.pending, (state) => {
                state.loading = true;
            })
            .addCase(getDailyUsage.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(getDailyUsage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export const {  } = dailyUsageSlice.actions;

export default dailyUsageSlice.reducer;